import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from 'Services/httpConfig'
import { Method } from 'Services/httpMethod'
import CommonApiPaths from 'Services/endpoints'
import AccountApiPaths from 'Application/Account/services/endpoints'
import { createPersistentBaseQuery } from 'Services/persistent-base-query'
import type {
  InsuranceExpertFields,
  AccessList,
  UserProfile,
  SetSsoData,
  GenerateAllAudios,
} from './common.types'
import {
  COMMON_CACHE_STORE,
  COMMON_CACHE_VERSION,
  COMMON_DB_STORE,
  persistRules,
} from './common.config'

export const commonApi = createApi({
  reducerPath: 'commonApi',
  baseQuery: createPersistentBaseQuery(axiosBaseQuery(), {
    persistRules: persistRules,
    storeName: COMMON_CACHE_STORE,
    dbName: COMMON_DB_STORE,
    version: COMMON_CACHE_VERSION,
  }),
  tagTypes: ['UserProfile', 'ExpertFields', 'AccessList', 'Audios'],
  endpoints: builder => ({
    // ---------------- Insurance Expert Fields ----------------
    getInsuranceExpertFieldsCurrentUser: builder.query<InsuranceExpertFields['RESULT'], void>({
      query: () => ({
        url: CommonApiPaths.Expert.GetInsuranceExpertFieldsCurrentUser,
        method: Method.GET,
      }),
      providesTags: ['ExpertFields'],
    }),

    // ---------------- Access List ----------------
    getAllAccessList: builder.query<AccessList['RESULT'], void>({
      query: () => ({
        url: CommonApiPaths.users.GetUserAccessList,
        method: Method.GET,
      }),
      providesTags: ['AccessList'],
    }),

    // ---------------- User Profile Info ----------------
    getUserProfile: builder.query<UserProfile['RESULT'], void>({
      query: () => ({
        url: AccountApiPaths.GetUserProfileInfo,
        method: Method.GET,
      }),
      providesTags: ['UserProfile'],
    }),

    // ---------------- Set SSO Data ----------------
    setSsoData: builder.mutation<SetSsoData['RESULT'], SetSsoData['ARG']>({
      query: data => ({
        url: CommonApiPaths.Expert.SetSsoData,
        method: Method.PUT,
        data,
      }),
      invalidatesTags: ['UserProfile', 'ExpertFields'],
    }),

    // ---------------- Generate All Audios ----------------
    generateAllAudios: builder.query<GenerateAllAudios['RESULT'], GenerateAllAudios['ARG']>({
      query: data => ({
        url: CommonApiPaths.Tts.RIVTextToSpeech,
        method: Method.POST,
        data,
        timeout: 60 * 1000,
      }),
      providesTags: ['Audios'],
    }),

    // ---------------- Generate Audio ----------------
    // generateAudio: builder.mutation<GenerateAudio['RESULT'], GenerateAudio['ARG']>({
    //   query: ({ input, model = 'fa_IR-amir-medium' }) => ({
    //     url: CommonApiPaths.Tts.GenerateAudio,
    //     method: Method.POST,
    //     baseURL: baseTtsUrl,
    //     data: { input, model },
    //     // responseType: 'blob',
    //     responseHandler: async (response: Response) => response.blob(),
    //   }),
    // }),
  }),
})

export const {
  useGetInsuranceExpertFieldsCurrentUserQuery,
  useLazyGetInsuranceExpertFieldsCurrentUserQuery,
  useGetAllAccessListQuery,
  useLazyGetAllAccessListQuery,
  useGetUserProfileQuery,
  useLazyGetUserProfileQuery,
  useSetSsoDataMutation,
  useGenerateAllAudiosQuery,
  useLazyGenerateAllAudiosQuery,
} = commonApi
